import Vue from 'vue'
import Vuex from 'vuex'
import LocalStore from '../fscommon/utils/localstore';
import VueWebSweocket from '../fscommon/websocket'
import router from '../router';
import FriendInfo from '../fscommon/websocket/model/friendInfo';
import StateSelectChatMessage from '../fscommon/websocket/model/stateSelectChatMessage'
import ProtoConversationInfo from '../fscommon/websocket/model/protoConversationInfo';
import StateConversationInfo from '../fscommon/websocket/model/stateConversationInfo';
import ConversationType from '../fscommon/websocket/model/conversationType';
import UnreadCount from '../fscommon/websocket/model/unReadCount';
import { DEFACULT_VUE_IMG } from '../fscommon/constant/system';
import Message from '../fscommon/websocket/message/message';
import ProtoMessage from '../fscommon/websocket/message/protomessage';
import MessageConfig from '../fscommon/websocket/message/messageConfig';
import RecallMessageNotification from '../fscommon/websocket/message/notification/recallMessageNotification';
import ProtoMessageContent from '../fscommon/websocket/message/protomessageContent';
import MessageStatus from '../fscommon/websocket/message/messageStatus';

Vue.use(Vuex)

const state = {
    currentUser: null,
    userId: LocalStore.getUserId(),
    token: LocalStore.getToken(),
    vueSocket: null,
    friendIds: [],
    userInfoList: [],
    friendInfos: [],
    groupInfoList: [],
    selectFriendId : 0,
    //选择的会话target
    selectTarget: '',
    firstLogin: false,
    //会话列表
    conversations: [],
    //消息列表
    messages: [],
    // 输入的搜索值
    searchText: '',
    groupMemberMap: new Map(),
    groupMemberTracker: 0,
    selectGroupTargetForMoblie: ''
}

const mutations = {
    initData(state) {
        state.userId = LocalStore.getUserId();
        state.token = LocalStore.getToken();
        const vueSocket = new VueWebSweocket();
        state.vueSocket = vueSocket;
        let conversations = LocalStore.getConversations();
        if(conversations){
            state.conversations = conversations;
        }
        let messages = LocalStore.getMessages();
        if(messages){
            state.messages = messages;
        }
        // state.selectTarget = LocalStore.getSelectTarget();
        let userInfoList = LocalStore.getUserInfoList();
        if(userInfoList){
            state.userInfoList = userInfoList;
        }
    },

    /**
     * 更新朋友Ids
     */
    updateFriendIds(state,value){
        if(value){
            state.friendIds = value;
        }
     },

    /**
     * 更新用户信息
     *  */ 
    updateUserInfos(state,userInfos){
        for(let currentUserInfo of userInfos){
           if(currentUserInfo.uid === state.userId){
               state.currentUser = currentUserInfo;
           }
           var isExist = false;
           var deleteIndex = 0;
           for(var index in state.userInfoList){
               var userInfo = state.userInfoList[index];
               if(userInfo.uid == currentUserInfo.uid){
                   isExist = true;
                   deleteIndex = index;
                   break;
               }
           }
           if(isExist){
              state.userInfoList.splice(deleteIndex,1,currentUserInfo)
           } else {
              state.userInfoList.push(currentUserInfo);
           }
        }
        this.commit("updateFriendInfos",userInfos)
    }, 

    updateFriendInfos(state,userInfos){
        for(var userInfo of userInfos){
            var friendId = state.friendIds.find(friendId => friendId == userInfo.uid)
            if(friendId){
                var friendInfo = state.friendInfos.find( friendInfo => {
                    if(friendInfo){
                       return friendInfo.title == userInfo.firstLetter
                    } else {
                        return false
                    }
                })
                if(friendInfo){
                    friendInfo.updateUserInfo(userInfo)
                } else {
                    friendInfo = FriendInfo.createFriendInfo(userInfo)
                    console.log("friend info "+friendInfo.title)

                    state.friendInfos.push(friendInfo)
                }
            }
        }

        //更新会话信息
        for(var stateConversationInfo of state.conversations){
            var user = state.userInfoList.find(user => user.uid === stateConversationInfo.conversationInfo.target);
            if(user){
                stateConversationInfo.name = user.displayName;
                stateConversationInfo.img = user.portrait;
            }
        }

        //更新消息列表信息
        for(var stateChatMessage of state.messages){
            var user = state.userInfoList.find(user => user.uid === stateChatMessage.target);
            if(user){
                stateChatMessage.name = user.displayName;
            }
        }
    },

    selectFriend (state, value) {
        console.log("selectFriend "+value)
        state.selectFriendId = value
     },

    changetFirstLogin(state,value){
        console.log("first login "+value);
        state.firstLogin = value;
    },

    addProtoMessage(state,protoMessage){
       var added = false;
       var isExistMessage = false;
       for(var stateChatMessage of state.messages){
           if(protoMessage.target == stateChatMessage.target){
               added = true;
               var isSameProtoMessage = stateChatMessage.protoMessages.find(message => message.messageId === protoMessage.messageId);
               if(!isSameProtoMessage){
                   stateChatMessage.protoMessages.push(protoMessage);
               } else {
                   isExistMessage = true;
               }
           }
       }
       if(!added){
          var stateChatMessage = new StateSelectChatMessage();
          var user = state.userInfoList.find(user => user.uid === protoMessage.target);
          if(user != null){
             stateChatMessage.name =  user.displayName;
          }
          stateChatMessage.target = protoMessage.target;
          stateChatMessage.protoMessages.push(protoMessage);
          state.messages.push(stateChatMessage);
       }
       //console.log("current message "+protoMessage.messageId +" isExist "+isExistMessage);
       if(!isExistMessage){
           var protoConversationInfo = new ProtoConversationInfo();
           protoConversationInfo.conversationType = protoMessage.conversationType;
           protoConversationInfo.target = protoMessage.target;
           protoConversationInfo.line = 0;
           protoConversationInfo.top = false;
           protoConversationInfo.slient = false;
           protoConversationInfo.timestamp = protoMessage.timestamp;
           protoConversationInfo.lastMessage = protoMessage;
           protoConversationInfo.unreadCount = new UnreadCount();

           this.commit('updateConversationInfo',protoConversationInfo);
       }
    },

    updateConversationInfo(state,protoConversationInfo){
        var update = false;
        var updateStateConverstaionInfo;
        var currentConversationInfoIndex;
        for(var index in state.conversations){
            var stateConverstaionInfo = state.conversations[index];
            if(stateConverstaionInfo.conversationInfo.conversationType == protoConversationInfo.conversationType 
                && stateConverstaionInfo.conversationInfo.target == protoConversationInfo.target){
                update = true;
                currentConversationInfoIndex = index;
                stateConverstaionInfo.conversationInfo.lastMessage = protoConversationInfo.lastMessage;
                stateConverstaionInfo.conversationInfo.timestamp = protoConversationInfo.lastMessage.timestamp;
                updateStateConverstaionInfo = stateConverstaionInfo;
                break;
            }
        }
        //新消息会话置顶
        if(update){
            state.conversations.splice(currentConversationInfoIndex,1);
            state.conversations.unshift(updateStateConverstaionInfo);
        }
        if(!update){
           updateStateConverstaionInfo = new StateConversationInfo();
           updateStateConverstaionInfo.conversationInfo = protoConversationInfo;

            //单聊会话
           if(protoConversationInfo.conversationType == ConversationType.Single){
                var user = state.userInfoList.find(user => user.uid === protoConversationInfo.target);
                if(user != null){
                    console.log("user "+user.displayName)

                    var name = user.displayName;
                    var img = user.portrait;
                    updateStateConverstaionInfo.name = name;
                    updateStateConverstaionInfo.img = img;
                } else {
                    updateStateConverstaionInfo.name = protoConversationInfo.target;
                    updateStateConverstaionInfo.img = DEFACULT_VUE_IMG;
                }
            } else {
                //群聊会话
                updateStateConverstaionInfo.name = protoConversationInfo.target;
                if(!updateStateConverstaionInfo.img){
                    state.vueSocket.getGroupInfo(protoConversationInfo.target,false);
                }
                updateStateConverstaionInfo.img = DEFACULT_VUE_IMG;
            }
            state.conversations.push(updateStateConverstaionInfo);
        }

        // 消息是否属于当前会话
        var isCurrentConversationMessage = (state.selectTarget === protoConversationInfo.target);
        // var visibilityStateVisible = (state.visibilityState === 'visible');
        // console.log("current message "+isCurrentConversationMessage +" visible "+visibilityStateVisible+" first login "+state.firstLogin);
        // //只显示接收消息，同一用户不同session，不再通知
        var isShowSendingMessage = protoConversationInfo.lastMessage.direction === 1;
        // //更新会话消息未读数
        if(!state.firstLogin && isShowSendingMessage && !isCurrentConversationMessage){
           //统计消息未读数,注意服务端暂时还没有将透传消息发送过来，原则上这里过来的消息都不是透传消息
           var num = updateStateConverstaionInfo.conversationInfo.unreadCount.unread += 1;
           var notifyBody = protoConversationInfo.lastMessage.content.searchableContent;
           console.log("target "+protoConversationInfo.target+" unread count "+num+ " notify body "+notifyBody);
        }
    },

    updateGroupInfos(state,groupInfos){
        for(let currentGroupInfo of groupInfos){
           var isExist = false;
           var deleteIndex = 0;
           for(var index in state.groupInfoList){
               var groupInfo = state.groupInfoList[index];
               if(groupInfo.target == currentGroupInfo.target){
                    isExist = true;
                    deleteIndex = index;
                    break;
               }
           }
           if(isExist){
              state.groupInfoList.splice(deleteIndex,1,currentGroupInfo);
           } else {
               state.groupInfoList.push(currentGroupInfo);
           }
        }
        console.log("group size "+state.groupInfoList.length);
        this.commit("updateConversationIntro",groupInfos);
    },

    /**
     * 更新会话简介，主要更新会话的名称与图像
     */
    updateConversationIntro(state,groupInfos){
        for(var groupInfo of groupInfos){
           var stateConverstaionInfo = state.conversations.find(stateConverstaionInfo => stateConverstaionInfo.conversationInfo.target === groupInfo.target);
           if(stateConverstaionInfo){
            console.log("update conversation name "+stateConverstaionInfo.name);
               stateConverstaionInfo.name = groupInfo.name;
               if(groupInfo.portrait){
                   stateConverstaionInfo.img = groupInfo.portrait;
               }
           }
           //更新会话标题

           var stateChatMessage = state.messages.find(stateChatMessage => stateChatMessage.target === groupInfo.target);
           if(stateChatMessage){
               stateChatMessage.name = groupInfo.name+"("+groupInfo.memberCount+")";
           }
        }
    },

    getGroupInfo(state,target){
        state.vueSocket.getGroupInfo(target,false);
    },

    selectConversation(state,value){
        state.selectTarget = value;
        console.log("selectConversation target "+value)
        //清除未读数
        var stateConversationInfo = state.conversations.find(stateConversationInfo => stateConversationInfo.conversationInfo.target === value);
        if(stateConversationInfo && stateConversationInfo.conversationInfo.unreadCount){
          stateConversationInfo.conversationInfo.unreadCount.unread = 0;
        }
     },

    // 退出
    LOGOUT(state) {
        state.user = null;
        state.token = null; 
        state.vueSocket.sendDisConnectMessage();
        state.vueSocket = null
        state.friendIds = null
        state.friendInfos = []
        state.userInfoList = []
        state.conversations = [];
        state.messages = [];
        state.selectFriendId = 0,
        state.selectTarget = '';
        state.firstLogin = false
        state.isLogin = false
        state.groupMemberTracker = 0;
        LocalStore.clearLocalStore();
        router.push("/login")
    },

    // 发送信息
    sendMessage (state, sendMessage){
        var message = Message.toMessage(state,sendMessage);
        var protoMessage = ProtoMessage.convertToProtoMessage(message);
        console.log("send protomessage "+JSON.stringify(protoMessage));
        
        // if(MessageConfig.isDisplayableMessage(protoMessage)){
        //     var stateConversationInfo = state.conversations.find(stateConversationInfo => stateConversationInfo.conversationInfo.target === protoMessage.target);
        //     stateConversationInfo.conversationInfo.lastMessage = protoMessage;
        //     stateConversationInfo.conversationInfo.timestamp = protoMessage.timestamp;

        //     var stateChatMessage = state.messages.find(chatmessage => chatmessage.target === protoMessage.target);
        //     if(!stateChatMessage){
        //         stateChatMessage = new StateSelectChatMessage();
        //         stateChatMessage.target = protoMessage.target;
        //         var friend = state.userInfoList.find(friend => friend.uid === protoMessage.target);
        //         if(friend != null){
        //           stateChatMessage.name =  friend.displayName;
        //         }
        //         stateChatMessage.protoMessages.push(protoMessage);
        //         state.messages.push(stateChatMessage);
        //     } else {
        //         stateChatMessage.protoMessages.push(protoMessage);
        //     }  
        // }

        this.commit("preAddProtoMessage",protoMessage)

        //发送消息到对端
        state.vueSocket.sendMessage(protoMessage);
    },

    //图片，视频类消息，需要先加入消息，然后上传成功后在更新message content
    preAddProtoMessage(state,protoMessage){
        
        if(MessageConfig.isDisplayableMessage(protoMessage)){
            var stateConversationInfo = state.conversations.find(stateConversationInfo => stateConversationInfo.conversationInfo.target === protoMessage.target);
            stateConversationInfo.conversationInfo.lastMessage = protoMessage;
            stateConversationInfo.conversationInfo.timestamp = protoMessage.timestamp;

            var stateChatMessage = state.messages.find(chatmessage => chatmessage.target === protoMessage.target);
            if(!stateChatMessage){
                stateChatMessage = new StateSelectChatMessage();
                stateChatMessage.target = protoMessage.target;
                var friend = state.userInfoList.find(friend => friend.uid === protoMessage.target);
                if(friend != null){
                  stateChatMessage.name =  friend.displayName;
                }
                stateChatMessage.protoMessages.push(protoMessage);
                state.messages.push(stateChatMessage);
            } else {
                stateChatMessage.protoMessages.push(protoMessage);
            }  
        }
    },

    //并没有所有会话消息,有可能出现切换会话的情况
    updateSendMessage(state,updateMessage){
        var stateChatMessage = state.messages.find(stateChatMessage => stateChatMessage.target === state.selectTarget);
        if(stateChatMessage){
            var protoMessage = stateChatMessage.protoMessages.find(message => message.messageId == updateMessage.messageId);
            if(protoMessage){
                protoMessage.status = MessageStatus.Sending;
                var messagePayload = updateMessage.messageContent.encode();
                protoMessage.content = ProtoMessageContent.toProtoMessageContent(messagePayload);
            }
        }
        state.vueSocket.sendMessage(protoMessage);
    },

    // 选择好友后，点击发送信息。判断在聊天列表中是否有该好友，有的话跳到该好友对话。没有的话
    // 添加该好友的对话 并置顶
    send (state) {
        let result = state.userInfoList.find(friend => friend.uid === state.selectFriendId)
        let stateConversationInfo = state.conversations.find(stateConversationInfo => stateConversationInfo.conversationInfo.target === result.uid)
        if( !stateConversationInfo ){
            state.selectTarget  = result.uid;
            var protoConversationInfo = new ProtoConversationInfo();
            protoConversationInfo.conversationType = ConversationType.Single;
            protoConversationInfo.target = result.uid;
            protoConversationInfo.line = 0;
            protoConversationInfo.top = false;
            protoConversationInfo.slient = false;
            protoConversationInfo.timestamp = new Date().getTime();
            protoConversationInfo.unreadCount = new UnreadCount();
            protoConversationInfo.lastMessage = null;

            var newStateConversationInfo = new StateConversationInfo();
            newStateConversationInfo.name = result.displayName;
            newStateConversationInfo.img = result.portrait;
            newStateConversationInfo.conversationInfo = protoConversationInfo;
            state.conversations.unshift(newStateConversationInfo);
        } else {
            state.selectTarget = stateConversationInfo.conversationInfo.target
            
        }
        router.push({ path: "/chat/group-chat"})
    },
    deleteConversation(state,targetId){
        //为防止再次收到消息，退出群组的发起人不应该在接收任何退出群组消息，防止再次产生会话
        var index = -1
        for(var i = 0; i<state.conversations.length; i++){
            if(state.conversations[i].conversationInfo.target == targetId){
                index = i;
                break;
            }
        }
        console.log("quit group index "+index)
        if(index != -1){
            state.conversations.splice(index,1);
        }
        //重新选择新的会话
        if(state.conversations.length > 0){
            state.selectTarget = state.conversations[0].conversationInfo.target
        }
    },

    updateProtoMessageUid(state,updateMessage){
        var stateChatMessage = state.messages.find(stateChatMessage => stateChatMessage.target === state.selectTarget);
        if(stateChatMessage){
            var protoMessage = stateChatMessage.protoMessages.find(message => message.messageId == updateMessage.messageId);
            if(protoMessage){
                protoMessage.messageUid = updateMessage.messageUid;
                return
            }
        } 
        //如果切换聊天，需要全局遍历，暂定
        for(var stateChatMessage of state.messages){
            for(var protoMessage of stateChatMessage.protoMessages){
                if(protoMessage.messageId == updateMessage.messageId){
                     protoMessage.messageUid = updateMessage.messageUid;
                }
            }
        }
    },

    updateMessageStatus(state,updateMessageStatus){
        var stateChatMessage = state.messages.find(stateChatMessage => stateChatMessage.target === state.selectTarget);
        if(stateChatMessage){
            var protoMessage = stateChatMessage.protoMessages.find(message => message.messageId == updateMessageStatus.messageId);
            if(protoMessage){
                protoMessage.status = updateMessageStatus.status;
                return
            }
        }
        //如果切换聊天，需要全局遍历，暂定。转发消息可能出现这个问题
        for(var stateChatMessage of state.messages){
            for(var protoMessage of stateChatMessage.protoMessages){
                if(protoMessage.messageId == updateMessageStatus.messageId){
                    protoMessage.status = updateMessageStatus.status;
                }
            }
        }
    },

    updateRecallMessageContent(state,notifyMessage){
        var found = false;
        for(var stateMessages of state.messages){
             for(var protoMessage of stateMessages.protoMessages){
                 if(protoMessage.messageUid == notifyMessage.messageUid){
                    var recallMessageContent = new RecallMessageNotification(notifyMessage.fromUser,notifyMessage.messageUid);
                    protoMessage.content = recallMessageContent.encode();
                    found = true
                    break;
                 }
             }
             if(found){
                break;
             }
        }
    },
}

const getters = {
    selectedFriend (state) {
        console.log("friend "+state.userInfoList.length)
        let friend = state.userInfoList.find(friend => friend.uid === state.selectFriendId);
        return friend
     },
     //筛选会话列表
    searchedConversationList(){
        return state.conversations.filter(conversationInfo => conversationInfo.name ? conversationInfo.name.includes(state.searchText): false);
    },
    selectedChat (state) {
        let chatMessage = state.messages.find(chatMessage => chatMessage.target === state.selectTarget);
        console.log("select target "+state.selectTarget)
        if(chatMessage == null){
            var conversationName = "";
            var conversationTarget = '';
            if(state.userInfoList){
              var friend = state.userInfoList.find(friend => friend.uid == state.selectTarget) 
              if(friend){
                  conversationName = friend.displayName;
                  conversationTarget = friend.uid;
              }
            }
           chatMessage = {
               name: conversationName,
               target: conversationTarget,
               protoMessages: []
           }
        }
        console.log("selectedChat "+chatMessage.name+" target "+chatMessage.target);
        return chatMessage
     },
    //当前会话是否为单聊会话
    isSingleConversation(){
        let stateConversation = state.conversations.find(stateConversation => stateConversation.conversationInfo.target === state.selectTarget);
        if(!stateConversation){
           return false;
        }
        return stateConversation.conversationInfo.conversationType === ConversationType.Single; 
     },
     messages (state) {
        let chatMessage = state.messages.find(chatMessage => chatMessage.target === state.selectTarget);
        if(chatMessage == null){
            return [];
        }
        return chatMessage.protoMessages;
    },
    unreadTotalCount(state){
        var total = 0;
        if(state.conversations){
            for(var stateConversationInfo of state.conversations){
                if(stateConversationInfo.conversationInfo.unreadCount){
                    total += stateConversationInfo.conversationInfo.unreadCount.unread;
                }
            }
        }
        return total;
    },
}


const actions = {
    initData: ({ commit }) => commit('initData'),
    updateFriendIds: ({ commit }, value) => commit('updateFriendIds', value),
    updateUserInfos: ({ commit }, value) => commit('updateUserInfos', value),
    selectFriend: ({ commit }, value) => commit('selectFriend', value),
    changetFirstLogin: ({ commit }, value) => commit('changetFirstLogin', value),
    addProtoMessage: ({ commit }, value) => commit('addProtoMessage', value),
    updateGroupInfos: ({ commit }, value) => commit('updateGroupInfos', value),
    selectConversation: ({ commit }, value) => commit('selectConversation', value),
    sendMessage: ({ commit }, msg) => commit('sendMessage', msg),
    send: ({ commit }) => commit('send'),
    deleteConversation: ({ commit }, value) => commit('deleteConversation', value),
    getGroupInfo: ({ commit }, value) => commit('getGroupInfo', value),
    updateProtoMessageUid: ({ commit }, value) => commit('updateProtoMessageUid', value),
    updateMessageStatus: ({ commit }, value) => commit('updateMessageStatus', value),
    updateRecallMessageContent: ({ commit }, value) => commit('updateRecallMessageContent', value),
    preAddProtoMessage: ({ commit }, value) => commit('preAddProtoMessage', value),
    updateSendMessage: ({ commit }, value) => commit('updateSendMessage', value),
}

const store = new Vuex.Store({
    state,
    mutations,
    getters,
    actions,
})

store.watch(
    state => state.conversations,
    value => {
        LocalStore.saveConverSations(value);
    },
    {
        deep : true
    }
)

store.watch(
    state => state.messages,
    value => {
        LocalStore.saveMessages(value);
    },
    {
        deep : true
    }
)

store.watch(
    state => state.userInfoList,
    value => {
        LocalStore.saveUserInfoList(value);
    },
    {
        deep : true
    }
)


export default store


// WEBPACK FOOTER //
// ./src/vuex/index.js